module.exports = __webpack_public_path__ + "static/img/9.9479b7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/9.png
// module id = L6iW
// module chunks = 0